import React from 'react'
const meta = require('../../../.taStandalonerc.yml')
import { MetaInfos } from 'components/metaInfos'
export const HeaderFromStandaloneRC = ({
  updated,

}: {
  updated?: string | JSX.Element
 
}) => (
  <div className='HeaderStandaloneRC'>
    <header className='ui vertical  very fitted  segment'>
      <div className='ui container'>
        <div className='ui header'>
          <h1>{meta.pageTitle}</h1>
          <h2>{meta.description}</h2>
        </div>
      </div>
    </header>
    <div className='ui vertical  very fitted  segment'>
      <div className='ui text container'>
        <MetaInfos
          authors={meta.author.split(', ')}
          updated={updated ? updated : undefined}
        />
      </div>
    </div>
  </div>
)
